import React from "react";
import { Grid } from "@mui/material";
import LabeledText from "../../Widgets/LabeledText";
import { TraumaHistoryFormValues } from "./interface";

interface ViewFieldsProps {
  formValues: TraumaHistoryFormValues;
}

export const ViewFields: React.FC<ViewFieldsProps> = ({ formValues }) => {
  return (
    <Grid container sx={{ rowGap: "24px" }}>
      <LabeledText
        label="Does the client have a history of trauma?"
        value={formValues.hasTraumaHistory === "YES" ? "Yes" : formValues.hasTraumaHistory === "NO" ? "No" : formValues.hasTraumaHistory || "-"}
      />
    </Grid>
  );
};

export default ViewFields;
